<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		TipoEvento, 
		API,
		cabecalhoPadraoRequisicao,
		StatusHttp } from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';
	
	let informacosAPICache;
	let tiposRelatorios = [];

	// variáveis para trabalhar com os dados do formulário
	let captchaUsuario, tipoRelatorioSeleciona;
	
	const tipoMIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
	const dispatch = createEventDispatcher();

	onMount(async => {
		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		let tr = informacosAPICache?.tipos_relatorios_sistema ?? [];
		tiposRelatorios = Object.entries(tr);
	});

	async function submeterFormulario(event) {
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: true,
				mensagem: 'Solicitando arquivo ...',
			});

			const resposta = await fetch(API("gerador-relatorios"), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					tipoRelatorio: tipoRelatorioSeleciona
				})
			}).catch(erros => {
				console.log(erros);
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Erro (falha na requisição)',
					conteudo: 'Não é possível baixar o arquivo, tente novamente mais tarde.'
				});
			}).finally( () => {
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
			});
			
			const blob = await resposta.blob();

			if (resposta.status == StatusHttp.OK) {
				const b = new Blob([blob], { type: tipoMIME });
				const urlBlob = URL.createObjectURL(b);
				
				window.open(URL.createObjectURL(b), '_blank');
				URL.revokeObjectURL(urlBlob);
				
				// limpa o catpcha preenchido e gera novo para evitar várias solicitações de arquivos
				captchaUsuario = "";
				// atualiza o store
				sCaptcha.update(novaString => gerarStringAleatoria());
			} else {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Erro',
					conteudo: 'Falha ao processar solicitação (arquivo/endpoint inválido ou erro ao gerar.).'
				});
			}
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<TBox 
	titulo="Gerador de Relatórios" 
	subtitulo="Arquivos gerados no formato de planilha (.xlsx)" 
	largura="8" 
	deslocamento="2" 
	icone="relatorio">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column is-full">
				<small class="has-text-primary">Selecione o tipo de relatório desejado:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={tipoRelatorioSeleciona} name="tipo_relatorio" required>
						<option value="">Selecione...</option>
						{#each tiposRelatorios as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<Captcha tamanho={3} />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="3" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Gerar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>